import React from "react";
import { useCurrentSecond } from "pages/Event/hooks/utils/useCurrentSecond";
import parse from "parse-duration";
import { formatInTimeZone } from "lib/formatInTimeZone";

type Props = {
  eventEndTimestamp: number;
  stopped?: boolean;
};

const oneDay = parse("1 day") as number;

export const EventCountdown = (props: Props) => {
  const timestamp = useCurrentSecond();

  const duration = React.useMemo(() => {
    if (props.stopped) {
      return 0;
    }
    return Math.max(0, props.eventEndTimestamp - timestamp);
  }, [props.stopped, props.eventEndTimestamp, timestamp]);

  const durationDays = React.useMemo(() => {
    return Math.floor(duration / oneDay);
  }, [duration]);

  const durationWithoutDays = React.useMemo(() => {
    return duration - durationDays * oneDay;
  }, [duration, durationDays]);

  const formattedDuration = React.useMemo(() => {
    return `${durationDays}D ${formatInTimeZone(durationWithoutDays, `HH'H' mm'M' ss'S'`, "UTC")}`;
  }, [durationDays, durationWithoutDays]);

  return <>{formattedDuration}</>;
};
